<template> 
  <div id="main-header">
    <header>
      <ul>
        <ul class="header-left">
        <li><a class="nav-link" @click="$emit('trigger-nav-link', 'main')" href="#">Main</a></li>
        <li><a class="nav-link" @click="$emit('trigger-nav-link', 'about')" href="#">About</a></li>
        <li><a class="nav-link" @click="$emit('show-contact-form', 'contactForm', 'overlay')" href="#">Contact</a></li>
        </ul>
        <ul v-show="showauthoptions" class="header-right">
        <li><button @click="$emit('showSignup', 'signup')">Signup</button></li>
        <li><button @click="$emit('showSignin', 'signin')" >Signin</button></li>
        </ul>
      </ul>
    </header>
  </div>
</template>

<script>
export default {
    name:"",
    components: {

    },
    props: {
      showauthoptions:{
        type:Boolean,
        default:true
      }
    },
    data: function(){
      return {

      }
    },
    computed: {

    },
    watch: {

    },
    methods: {

    },
    beforeCreate(){
    // console.log('nothing gets created before me')
    },
    created(){
    },
    beforeMount(){
    },
    mounted(){
    },
    beforeUpdate(){
    },
    updated(){
    },
    beforeDestroy(){
    },
    destroyed(){
    }

}
</script>

<style scoped>
header {
  background: rgb(2,0,36);
  background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(62,190,190,1) 35%, rgba(0,212,255,1) 100%);
  padding: 10px;
}
header ul {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
  justify-content: space-between;
}
header ul ul {
  display: flex;
  justify-content: space-between;
  /*min-width:10.5%;*/
  min-width:111px;
}
.header-left li {
  transition: all 0.5s ease;
  margin-right: 1.5em;
  margin-left: 10px;
}
.header-left li a {
  transition: all 0.5s ease;
}
.header-left li a:hover {
  color: #3ebebe;
}
.header-left {
  display: flex;
  align-items: center;
  transform: translateX(-300px);
  animation: outLeft 0.7s 1 normal forwards 
}
.header-right {
  transform: translateX(300px);
  animation: outRight 0.7s 1 normal ease-out forwards
}
.header-right li button {
  color: white;
  background-color: #17CFEE;
  padding: 10px;
  margin-right: 1em;
  font-family: 'Noto Sans', sans-serif;
  border-radius: 21px;
  box-shadow: -2px 6px 10px -3px #aaaaaa;
}
.header-right li button:hover {

}

.nav-link {
  text-decoration:none;
  color: white;
  text-shadow: 2px 1px 3px #3ebebe;
  font-size: 1.1em;
}

.header-right {

}
@keyframes fontbulger {
  0% {
    font-size: 10px;
  }
  30% {
    font-size: 15px;
  }
  100% {
    font-size: 12px;
  }
}
@keyframes outRight {
0% {
  transform: translateX(300px);
  } 
100% {
  transform: translateX(0px);  
  }
}

@keyframes outLeft {
0% {
  transform: translateX(-300px);
  } 
100% {
  transform: translateX(0px);  
  }
}

@keyframes fade-in {
0% { opacity:0;
  } 
100% {
  opacity: 1; 
  }
}

@keyframes fade-out {
0% {
  opacity:1;
  } 
100% {
  opacity: 0; 
  }
}

@keyframes flexText {
0% {
  } 
50% {
  font-size: 255%;
} 
100% {
  }
}
@keyframes fontbulger {
  0% {
    font-size: 10px;
  }
  30% {
    font-size: 15px;
  }
  100% {
    font-size: 12px;
  }
}

</style>
